export default __webpack_public_path__ + "static/media/deliland-brownsugar-icon.02bc638e.png";